'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosThunderstorm = function IoIosThunderstorm(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.5 21.3h3.1l-6.9 10 2.3-7.5h-4.1l1.2-6.3h5.6z m-5.4-5h8.3l-1.2 3.7h3.7l-2.6 3.8h1.5c2.8 0 5.1-2.4 5.1-5.2s-2.3-5.1-5.1-5.1h-0.6c-0.6-2.7-3-4.7-5.9-4.7-3.4 0-6.1 2.7-6.1 6v0.7c-2.1 0.1-3.7 2-3.7 4.1 0 2.3 1.9 4.2 4.1 4.2h1.1z' })
        )
    );
};

exports.default = IoIosThunderstorm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-thunderstorm.js
// module id = 2783
// module chunks = 168707334958949